import { Route, Routes } from 'react-router-dom';
import { OfferEventTransfer } from './components/OfferEventTransfer';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function OfferEventTransferRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.OFFER_EVENT_TRANSFER) && <Route index element={<OfferEventTransfer />} />}
        </Routes>
    );
}
